export default __webpack_public_path__ + "static/media/expertM.9a2f80eb.svg";